module.exports = __webpack_public_path__ + "media/images/lb/657-61679121f1d5ed7ca847e88b554e429e.svg";